import { Link } from 'react-router-dom';
import { FacetMark } from './Logo';
import { C, MONO } from '../lib/theme';

const colLabel: React.CSSProperties = {
  fontFamily: MONO,
  fontSize: 10,
  letterSpacing: '0.06em',
  color: C.faint,
  textTransform: 'uppercase',
};
const link: React.CSSProperties = { color: C.muted };

export function Footer() {
  return (
    <footer style={{ borderTop: `1px solid ${C.border}`, background: C.bg }}>
      <div
        style={{
          maxWidth: 'var(--fx-shell-max)',
          margin: '0 auto',
          padding: '52px var(--fx-gutter) 40px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          flexWrap: 'wrap',
          gap: 32,
        }}
      >
        <div style={{ maxWidth: 300, display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <FacetMark size={24} variant="ink" />
            <span style={{ fontSize: 16, fontWeight: 600 }}>Facet</span>
          </div>
          <div style={{ fontSize: 14, color: C.muted }}>Your face, quantified. Kindly.</div>
          <div style={colLabel}>On-device · Private · A guide, not a verdict</div>
        </div>
        <div style={{ display: 'flex', gap: 56, flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 9, fontSize: 13.5 }}>
            <span style={colLabel}>Product</span>
            <Link to="/scan" style={link}>Web scan</Link>
            <Link to="/report" style={link}>Live demo</Link>
            <Link to="/pricing" style={link}>Pricing</Link>
            <Link to="/download" style={link}>Get the app</Link>
            <Link to="/account" style={link}>Account</Link>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 9, fontSize: 13.5 }}>
            <span style={colLabel}>Learn</span>
            <Link to="/guides" style={link}>Guides</Link>
            <Link to="/method" style={link}>Method and limits</Link>
            <Link to="/privacy" style={link}>Privacy-first</Link>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 9, fontSize: 13.5 }}>
            <span style={colLabel}>Legal</span>
            <Link to="/legal/privacy" style={link}>Privacy policy</Link>
            <Link to="/legal/terms" style={link}>Terms</Link>
            <a href="mailto:support@facetlooks.com" style={link}>Support</a>
          </div>
        </div>
      </div>
      <div style={{ maxWidth: 'var(--fx-shell-max)', margin: '0 auto', padding: '0 var(--fx-gutter) 36px' }}>
        <div
          style={{
            borderTop: `1px solid ${C.border}`,
            paddingTop: 18,
            fontSize: 12.5,
            lineHeight: 1.6,
            color: C.faint,
          }}
        >
          © 2026 Facet · facetlooks.com. Measurement runs in your browser; your photo is discarded after
          measurement unless you opt in to save it privately to your account. Not medical advice. Scores
          estimate perceived facial harmony for your own goals. A guide, not a measure of your worth. 17+.
        </div>
      </div>
    </footer>
  );
}
